import { lazy } from 'react';

const CharityVettingDonationPreferencesEntry = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingDonationPreferences" */ '../components/steps/donation-preferences/DonationPreferences'
    ),
);

export default CharityVettingDonationPreferencesEntry;
